import type { GameDescriptor } from '../game-registry.js';
import { WheelScene } from '../scenes/WheelScene.js';

export const wheelDescriptor: GameDescriptor = { code: 'wheel', scene: WheelScene, supportsAuto: true };
